import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'

const WebhookProfileSetup = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Webhook profiles
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            Adding new webhook profile allows you to integrate with external notification app.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooks}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </div>

export default WebhookProfileSetup
